"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateComment = void 0;
const types_1 = require("../../types");
const selectors_1 = require("../../exports/store/selectors");
const command_manager_1 = require("../../command_manager");
const model_1 = require("../../model");
exports.updateComment = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { recordId, datasheetId, comments, emojiAction } = options;
        const actions = [];
        const record = (0, selectors_1.getRecord)(state, recordId, datasheetId);
        if (!record) {
            return null;
        }
        const updateCommentAction = model_1.DatasheetActions.updateComment2Action({
            datasheetId,
            recordId,
            updateComments: [comments],
            emojiAction
        });
        if (!updateCommentAction) {
            return null;
        }
        actions.push(...updateCommentAction);
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
//# sourceMappingURL=update_comment.js.map